import axios from 'axios';

const request = async (method, body = {}, signal) => {
    const response = await axios.post(
        `${global.backingsEndpoint}surveyControl/${method}`,
        body,
        { signal }
    );

    return response.data;
};

export const getSurveyList = (signal) => request('getList', {}, signal);

export const getSurvey = (key, questionIndex, signal) => {
    const body = { key };

    if (Number.isInteger(questionIndex)) {
        body.questionIndex = questionIndex;
    }

    return request('getSurvey', body, signal);
};

export const submitSurvey = (result) => request('submit', { result });
